import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS,SHIP_TO_ADDRESS_FIELDS } from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';

type Field = {
  key: string;
};

type Card = {
  key: string;
  hideSameAs?: boolean;
  fields?: Field[];
  fieldWrapper?: string;
};

type PageTemplate = {
  route: string;
  cards: Card[];
};

describe('ShipTo Page Template', () => {
  it('exports pages array with one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const shipToPage = (pages as PageTemplate[]).find(p => p.route === PAGE_ROUTES.shipTo);

  it('has correct route', () => {
    expect(shipToPage).toBeDefined();
    expect(shipToPage?.route).toBe(PAGE_ROUTES.shipTo);
  });

  it('contains expected cards', () => {
    expect(Array.isArray(shipToPage?.cards)).toBe(true);
    expect(shipToPage?.cards.map(c => c.key)).toEqual([
      CARD_CATEGORIES.address,
      CARD_CATEGORIES.additionalAttachmentCard,
      CARD_CATEGORIES.privacyPolicy
    ]);
  });

  describe('Address Card', () => {
    const addressCard = shipToPage?.cards.find(c => c.key === CARD_CATEGORIES.address);

    it('has hideSameAs enabled', () => {
      expect(addressCard).toBeDefined();
      expect(addressCard?.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(addressCard?.fields?.map(f => f.key)).toEqual([
        SHIP_TO_ADDRESS_FIELDS.address,
        SHIP_TO_ADDRESS_FIELDS.taxNumber1,
        SHIP_TO_ADDRESS_FIELDS.taxNumber2,
        SHIP_TO_ADDRESS_FIELDS.email
      ]);
    });

    it('has correct fieldWrapper', () => {
      expect(addressCard?.fieldWrapper).toBe(CARD_CATEGORIES.shipTo);
    });
  });

  describe('Attachment & Privacy Cards', () => {
    it('contains additionalAttachmentCard', () => {
      const attachmentCard = shipToPage?.cards.find(c => c.key === CARD_CATEGORIES.additionalAttachmentCard);
      expect(attachmentCard).toBeDefined();
      expect(attachmentCard?.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = shipToPage?.cards.find(c => c.key === CARD_CATEGORIES.privacyPolicy);
      expect(privacyCard).toBeDefined();
      expect(privacyCard?.fields).toBeUndefined();
    });
  });
});